/** NCAA worksheet-style numeric grade points (0.0 - 4.0 per credit). */
export function gradeToPoints(gradeRaw: string): number | null {
    const normalized = gradeRaw.trim().replace(",", ".");
    if (!normalized) return null;
    const points = Number.parseFloat(normalized);
    if (Number.isNaN(points) || points < 0 || points > 4) {
        return null;
    }
    return points;
}

export function parseCredits(creditsRaw: string): number | null {
    const n = parseFloat(creditsRaw.trim().replace(",", "."));
    if (Number.isNaN(n) || n < 0) return null;
    return n;
}

export function rowQualityPoints(gradeRaw: string, creditsRaw: string): number {
    const gp = gradeToPoints(gradeRaw);
    const cr = parseCredits(creditsRaw);
    if (gp == null || cr == null) return 0;
    return gp * cr;
}
